import { ChoiceGroup, ComboBox, DatePicker, DayOfWeek, DefaultButton, IChoiceGroupOption, IComboBoxOption, Label, PrimaryButton, TextField } from "@fluentui/react";
import { DateTime } from 'ioip-base/lib/common';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { defaultIContactoExtended } from '../../classes/contacto-extended';
import { Sede } from '../../classes/shared';
import { AtencionPreferencialEnum } from '../../classes/shared/atencion-preferencias.enum';
import { $_, DatePickerStrings, INivelEducativo, IProfesion, ITipoIdentificacion, ITipoPersona, ITipoSolicitante, ValidationResult, onFormatDate, validateObject, validator } from '../../ioip/sdk/base';
import { PqrWebService } from '../../services/services';
import { TipoIdentificacionEnum } from '../create-contact-component/tipo-identificacion-enum';
import { TipoPersonaEnum } from '../create-contact-component/tipo-persona-enum';
import { ReCaptchaComponent } from '../recaptcha/recaptcha.component';
import { IEditContactComponentProps } from './edit-contact.props';
import { IEditContactComponentState } from './edit-contact.state';
import { ICountry } from "@ioip/archivox/lib";

export class EditContactComponent extends React.Component<IEditContactComponentProps, IEditContactComponentState> {

  private _recaptcha: ReCaptchaComponent;
  private _pqrWebService: PqrWebService;
  private _validations: { [ key: string ]: any[] } = {
    IdTipoIdentificacion: [ validator.invalid(0, 'Campo requerido') ],
    Identificacion: [ validator.required(true), validator.maxLength(128) ],
    Nombres: [ validator.required(true), validator.maxLength(128) ],
    Apellidos: [ validator.required(true), validator.maxLength(128) ],
    Direccion: [ validator.maxLength(128) ],
    Barrio: [ validator.maxLength(100) ],
    Telefono: [ validator.maxLength(20) ],
    Extension: [ validator.maxLength(15) ],
    Celular: [ validator.maxLength(20) ],
    Email: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    Email2: [
      validator.required(true),
      validator.maxLength(128),
      validator.email(),
      validator.custom(this._checkEmail.bind(this))
    ],
    IdCiudad: [ validator.invalid(0, 'Campo requerido') ],
    IdDepartamento: [ validator.invalid(0, 'Campo requerido') ],
    IdPais: [ validator.invalid(0, 'Campo requerido') ],
  };

  constructor(props: any) {
    super(props);

    this.state = {
      model: defaultIContactoExtended(),
      errors: {},
      isSaving: false,
      autorizaPoliticaPrivacidad: false,
      ciudades: [],
      ciudadesCO: [],
      departamentos: [],
      departamentosCO: [],
      paises: [],
      paisesCO: [],
      tiposIdentificacion: [],
      tiposIdentificacionCO: [],
      tiposIdentificacionCOApoderado: [],
      preguntas: [],
      generos: [],
      gruposEtnicos: [],
      discapacidades: [],
      atencionPreferencial: [],
      tiposPersona: [],
      tiposPersonaCO: [],
      fechaModificacion: '',
      nivelEducativo: [],
      profesiones: [],
      mostrarProfesion: true,
      mostrarTipoSolicitante: true,
      tiposSolicitante: [],
      opcionesSeleccionGrupo: [
        {
          key: '0',
          text: 'No',
        },
        {
          key: '1',
          text: 'Sí',
        }
      ]
    };

    this._pqrWebService = new PqrWebService();

  }

  async componentDidMount(): Promise<void> {

    const result = await Promise.all([
      this._pqrWebService.getAllCountriesAsync(),
      this._pqrWebService.getAllDepartmentsAsync(),
      this._pqrWebService.getAllCitiesAsync(),
      this._pqrWebService.getAllIdentificationTypesAsync(),
      this._pqrWebService.getAllQuestionsAsync(),
      this._pqrWebService.getAllPreferentialCareTypesAsync(),
      this._pqrWebService.getAllDisabilitiesAsync(),
      this._pqrWebService.getAllGendersAsync(),
      this._pqrWebService.getAllEthnicGroupsAsync(),
      this._pqrWebService.getAllPersonTypesAsync()
    ]) as any;

    const [ educationLevels, professions, applicantTypes ] = await Promise.all([
      this._pqrWebService.getAllEducationLevelsAsync(),
      this._pqrWebService.getAllProfessionsAsync(),
      this._pqrWebService.getAllApplicantTypeAsync()
    ]) as any;

    const state = {
      model: {
        ...this.state.model,
        IdContacto: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idcontacto')),
        IdTipoContacto: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipocontacto')),
        Nombres: sessionStorage.getItem('ioip.pqr-web.session.nombres'),
        Apellidos: sessionStorage.getItem('ioip.pqr-web.session.apellidos'),
        IdTipoIdentificacion: parseInt(sessionStorage.getItem('ioip.pqr-web.session.tipoid')),
        Identificacion: sessionStorage.getItem('ioip.pqr-web.session.identificacion'),
        Email: sessionStorage.getItem('ioip.pqr-web.session.email'),
        Email2: sessionStorage.getItem('ioip.pqr-web.session.email'),
        Celular: sessionStorage.getItem('ioip.pqr-web.session.celular'),
        Telefono: sessionStorage.getItem('ioip.pqr-web.session.telefono'),
        Direccion: sessionStorage.getItem('ioip.pqr-web.session.direccion'),
        Barrio: sessionStorage.getItem('ioip.pqr-web.session.barrio'),
        Extension: sessionStorage.getItem('ioip.pqr-web.session.extension'),
        IdPais: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idpais')),
        IdDepartamento: parseInt(sessionStorage.getItem('ioip.pqr-web.session.iddepartamento')),
        IdCiudad: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idciudad')),
        CodigoPostal: sessionStorage.getItem('ioip.pqr-web.session.codigopostal'),
        IdAntencionPreferencial: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idantencionpreferencial')),
        IdDiscapacidad: parseInt(sessionStorage.getItem('ioip.pqr-web.session.iddiscapacidad')),
        IdGenero: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idgenero')),
        IdGrupoEtnico: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idgrupoetnico')),
        NombreRepresentante: sessionStorage.getItem('ioip.pqr-web.session.nombrerepresentante'),
        EmailRepresentante: sessionStorage.getItem('ioip.pqr-web.session.emailrepresentante'),
        CargoRepresentante: sessionStorage.getItem('ioip.pqr-web.session.cargorepresentante'),
        TelefonoRepresentante: sessionStorage.getItem('ioip.pqr-web.session.telefonorepresentante'),
        IdTipoPersona: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipopersona')),
        PrimerNombre: sessionStorage.getItem('ioip.pqr-web.session.primernombre'),
        SegundoNombre: sessionStorage.getItem('ioip.pqr-web.session.segundonombre'),
        PrimerApellido: sessionStorage.getItem('ioip.pqr-web.session.primerapellido'),
        SegundoApellido: sessionStorage.getItem('ioip.pqr-web.session.segundoapellido'),
        IdNivelEducativo: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idnivelEducativo')),
        IdProfesion: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idprofesion')),
        IdTipoEntidad: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipoentidad')),

        ActuaComoApoderado: sessionStorage.getItem('ioip.pqr-web.session.actuacomoapoderado') === 'true' ? true : false,
        IdTipoIdentificacionApoderado: parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipoidentificacionapoderado')),
        IdentificacionApoderado: sessionStorage.getItem('ioip.pqr-web.session.identificacionapoderado'),
        NombresApoderado: sessionStorage.getItem('ioip.pqr-web.session.nombresapoderado'),
        ApellidosApoderado: sessionStorage.getItem('ioip.pqr-web.session.apellidosapoderado'),
        DireccionApoderado: sessionStorage.getItem('ioip.pqr-web.session.direccionapoderado'),
        TelefonoApoderado: sessionStorage.getItem('ioip.pqr-web.session.telefonoapoderado'),
        EmailApoderado: sessionStorage.getItem('ioip.pqr-web.session.emailapoderado'),
        AutorizaNotificacionEmail: JSON.parse(sessionStorage.getItem('ioip.pqr-web.session.autorizanotificacionemail')),
        AutorizaNotificacionFisica: JSON.parse(sessionStorage.getItem('ioip.pqr-web.session.autorizanotificacionfisica')),
        AutorizaLlamadaFijo: JSON.parse(sessionStorage.getItem('ioip.pqr-web.session.autorizallamadafijo')),
        AutorizaLlamadaCelular: JSON.parse(sessionStorage.getItem('ioip.pqr-web.session.autorizallamadacelular')),
        AutorizaTratamientoDatos: JSON.parse(sessionStorage.getItem('ioip.pqr-web.session.autorizatratamientodatos'))
      },
      paises: result[ 0 ],
      paisesCO: result[ 0 ].map((o: ICountry) => ({ key: o.countryId, text: o.name })),
      departamentos: result[ 1 ],
      departamentosCO: result[ 1 ].filter(o => o.IdPais === Number(parseInt(sessionStorage.getItem('ioip.pqr-web.session.idpais')))).map(o => ({ key: o.IdDepartamento, text: o.Nombre })),
      ciudades: result[ 2 ],
      ciudadesCO: result[ 2 ].filter(o => o.IdDepartamento === Number(parseInt(sessionStorage.getItem('ioip.pqr-web.session.iddepartamento')))).map(o => ({ key: o.IdCiudad, text: o.Nombre })),
      tiposIdentificacion: result[ 3 ],
      tiposIdentificacionCO: result[ 3 ].map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
      tiposIdentificacionCOApoderado: result[ 3 ].map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
      atencionPreferencial: result[ 5 ].filter(o => o.Activo).map(o => ({ key: o.IdAntencionPreferencial, text: o.Nombre })),
      discapacidades: result[ 6 ].map(o => ({ key: o.IdDiscapacidad, text: o.Nombre })),
      gruposEtnicos: result[ 8 ].map(o => ({ key: o.IdGrupoEtnico, text: o.Nombre })),
      tiposPersona: result[ 9 ],
      tiposPersonaCO: result[ 9 ].map((o: ITipoPersona) => ({ key: o.IdTipoPersona, text: o.Nombre })),
      generos: result[ 7 ].map((o: { IdGenero: any; Nombre: any; }) => ({ key: o.IdGenero, text: o.Nombre })),
      fechaModificacion: sessionStorage.getItem('ioip.pqr-web.session.fechaModificacion'),
      nivelEducativo: educationLevels.filter(o => o.Activo).map((o: INivelEducativo) => ({ key: o.IdNivelEducativo, text: o.Nombre })),
      profesiones: professions.filter(o => o.Activo).map((o: IProfesion) => ({ key: o.IdProfesion, text: o.Nombre })),
      mostrarProfesion: Sede.Shared.Context.EnableContactProfession,
      mostrarTipoSolicitante: Sede.Shared.Context.EnableContactRequesterType,
      tiposSolicitante: applicantTypes.filter(o => o.Activo && o.IdTipoPersona === parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipopersona'))).map((o: ITipoSolicitante) => ({ key: o.IdTipoSolicitante, text: o.Nombre }))
    };

    if (sessionStorage.getItem('ioip.pqr-web.session.fechaNacimiento') !== "") {
      state.model.FechaNacimiento = new Date(sessionStorage.getItem('ioip.pqr-web.session.fechaNacimiento'));
    }

    if (parseInt(sessionStorage.getItem('ioip.pqr-web.session.tipoid')) === TipoIdentificacionEnum.TarjetaIdentidad) {
      let result = await this._pqrWebService.getChildGendersAsync();
      state.generos = result.map(o => ({ key: o.IdGenero, text: o.Nombre }));
    }

    if (parseInt(sessionStorage.getItem('ioip.pqr-web.session.idtipopersona')) === TipoPersonaEnum.PersonaNatural) {
      let result = await this._pqrWebService.getIdentificationTypesByIdPersonaAsync(TipoPersonaEnum.PersonaNatural);
      state.tiposIdentificacionCOApoderado = result.filter(o => o.IdTipoIdentificacion !== TipoIdentificacionEnum.TarjetaIdentidad).map((o: ITipoIdentificacion) => ({ key: o.IdTipoIdentificacion, text: o.Nombre }));
    }

    this.setState(state);
  }

  private async _onChangeOpcionActuaComoApoderado(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): Promise<void> {
    this.setState({
      model: {
        ...this.state.model,
        ActuaComoApoderado: option.key === '0' ? false : true,
        IdTipoIdentificacionApoderado: 0,
        IdentificacionApoderado: '',
        NombresApoderado: '',
        ApellidosApoderado: ''
      }
    });
  }

  private _onChangeOpcionAutorizaNotificacionEmail(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaNotificacionEmail: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaLlamadaCelular(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaLlamadaCelular: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaLlamadaFijo(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaLlamadaFijo: option.key === '0' ? false : true
      }
    });
  }

  private _onChangeOpcionAutorizaNotificacionFisica(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    this.setState({
      model: {
        ...this.state.model,
        AutorizaNotificacionFisica: option.key === '0' ? false : true
      }
    });
  }

  render(): JSX.Element {

    const value = this.state.tiposIdentificacion.find(o => o.IdTipoIdentificacion === this.state.model.IdTipoIdentificacion);
    const emailLabel = value?.IdTipoPersona === 2 ? 'Correo electrónico para notificaciones' : 'Correo electrónico';
    const confirmEmailLabel = value?.IdTipoPersona === 2 ? 'Confirmar correo electrónico para notificaciones' : 'Confirmar correo electrónico';

    if (!this.isAuthenticate) {
      return <Redirect to='/#/home' />;
    }
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          <h1 className="ms-font-xl ms-fontWeight-semibold">Actualizar información</h1>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          <ComboBox
            label='Tipo de persona'
            selectedKey={this.state.model.IdTipoPersona}
            onChange={(_, value) => this._onChangeComboBox('IdTipoPersona', value)}
            options={this.state.tiposPersonaCO}
            useComboBoxAsMenuWidth={true}
            disabled={true}
            errorMessage={this.state.errors[ 'IdTipoPersona' ]} />
        </div>
      </div>

      {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaNatural) &&
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ComboBox
              label='Atención preferencial o prioritaria'
              selectedKey={this.state.model.IdAntencionPreferencial}
              onChange={(_, value) => this._onChangeComboBox('IdAntencionPreferencial', value)}
              options={this.state.atencionPreferencial}
              useComboBoxAsMenuWidth={true}
              required={this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural}
            />
          </div>
          {
            this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.GrupoEtnico &&
            <div className='ms-Grid-col ms-u-sm4'>
              <ComboBox
                label='Auto reconocimiento étnico-racial'
                selectedKey={this.state.model.IdGrupoEtnico}
                onChange={(_, value) => this._onChangeComboBox('IdGrupoEtnico', value)}
                options={this.state.gruposEtnicos}
                useComboBoxAsMenuWidth={true}
              />
            </div>
          }
          {this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.Discapacidad &&
            <div className='ms-Grid-col ms-u-sm4'>
              <ComboBox
                label='Presenta discapacidad'
                selectedKey={this.state.model.IdDiscapacidad}
                onChange={(_, value) => this._onChangeComboBox('IdDiscapacidad', value)}
                options={this.state.discapacidades}
                useComboBoxAsMenuWidth={true}
              />
            </div>
          }
        </div>
      }

      {
        this.state.mostrarTipoSolicitante &&
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ComboBox
              label='Usted se identifica como'
              selectedKey={this.state.model.IdTipoEntidad}
              onChange={(_, value) => this._onChangeComboBox('IdTipoEntidad', value)}
              options={this.state.tiposSolicitante}
              useComboBoxAsMenuWidth={true}
              errorMessage={this.state.errors[ 'IdTipoEntidad' ]}
              required={this.state.mostrarTipoSolicitante}
            />
          </div>
        </div>
      }

      {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural &&
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-sm12 ms-md6 ms-lg12'>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.ActuaComoApoderado === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionActuaComoApoderado.bind(this)}
              label={'¿Actúa cómo apoderado?'}
            />
          </div>
        </div>
      }

      {this.state.model.ActuaComoApoderado && this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12'>
            <Label>
              <span style={{ color: 'rgb(0, 120, 212)' }}>Datos del apoderado</span>
            </Label>
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ComboBox
              autoComplete='on'
              errorMessage={this.state.errors[ 'IdTipoIdentificacionApoderado' ]}
              label='Tipo de identificación'
              onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacionApoderado', value)}
              options={this.state.tiposIdentificacionCOApoderado}
              required={this.state.model.ActuaComoApoderado}
              selectedKey={this.state.model.IdTipoIdentificacionApoderado}
              useComboBoxAsMenuWidth={true}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              errorMessage={this.state.errors[ 'IdentificacionApoderado' ]}
              label={'Número de identificación'}
              maxLength={15}
              onChange={(_, value) => this._onChangeTextField('IdentificacionApoderado', value)}
              placeholder={'Número de identificación del apoderado'}
              required={this.state.model.ActuaComoApoderado}
              value={this.state.model.IdentificacionApoderado}
            />
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder={'Nombres'}
              label={'Nombres'}
              maxLength={128}
              required={this.state.model.ActuaComoApoderado}
              errorMessage={this.state.errors[ 'NombresApoderado' ]}
              onChange={(_, value) => this._onChangeTextField('NombresApoderado', value)}
              value={this.state.model.NombresApoderado}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder={'Apellidos'}
              label={'Apellidos'}
              maxLength={128}
              required={this.state.model.ActuaComoApoderado}
              errorMessage={this.state.errors[ 'ApellidosApoderado' ]}
              onChange={(_, value) => this._onChangeTextField('ApellidosApoderado', value)}
              value={this.state.model.ApellidosApoderado}
            />
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder={'Email'}
              label={'Email'}
              maxLength={128}
              required={this.state.model.ActuaComoApoderado}
              errorMessage={this.state.errors[ 'EmailApoderado' ]}
              onChange={(_, value) => this._onChangeTextField('EmailApoderado', value)}
              value={this.state.model.EmailApoderado}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder={'Dirección'}
              label={'Dirección'}
              maxLength={128}
              required={false}
              errorMessage={this.state.errors[ 'DireccionApoderado' ]}
              onChange={(_, value) => this._onChangeTextField('DireccionApoderado', value)}
              value={this.state.model.DireccionApoderado}
            />
          </div>
        </div>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder={'Teléfono de contacto'}
              label={'Teléfono de contacto'}
              maxLength={64}
              errorMessage={this.state.errors[ 'TelefonoApoderado' ]}
              onChange={(_, value) => this._onChangeTextField('TelefonoApoderado', value)}
              value={this.state.model.TelefonoApoderado}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
          </div>
        </div>
      </>}


      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          <Label>
            <span style={{ color: 'rgb(0, 120, 212)' }}>Información personal</span>
          </Label>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm6'>
          <ComboBox
            label='Tipo de identificación'
            selectedKey={this.state.model.IdTipoIdentificacion}
            onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacion', value)}
            options={this.state.tiposIdentificacionCO}
            useComboBoxAsMenuWidth={true}
            errorMessage={this.state.errors[ 'IdTipoIdentificacion' ]}
            disabled={true}
          />
        </div>
        {((this.state.model.IdTipoIdentificacion) != TipoIdentificacionEnum.Nit) &&
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='Identificación'
              label='Identificación'
              maxLength={12}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
              errorMessage={this.state.errors[ 'Identificacion' ]}
              value={this.state.model.Identificacion}
              readOnly={true}
            />
          </div>
        }
        {((this.state.model.IdTipoIdentificacion) === TipoIdentificacionEnum.Nit) &&
          <div className='ms-Grid-col ms-u-sm6'>
            <TextField
              placeholder='NIT'
              label='NIT'
              maxLength={12}
              required={true}
              onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
              errorMessage={this.state.errors[ 'Identificacion' ]}
              value={this.state.model.Identificacion}
            />
          </div>
        }
      </div>

      {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaNatural) &&
        <div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder='Primer nombre'
                label='Primer nombre'
                maxLength={64}
                required={true}
                onChange={(_, value) => this._onChangeTextField('PrimerNombre', value)}
                errorMessage={this.state.errors[ 'PrimerNombre' ]}
                value={this.state.model.PrimerNombre}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder='Segundo nombre'
                label='Segundo nombre'
                maxLength={64}
                onChange={(_, value) => this._onChangeTextField('SegundoNombre', value)}
                errorMessage={this.state.errors[ 'SegundoNombre' ]}
                value={this.state.model.SegundoNombre}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder='Primer apellido'
                label='Primer apellido'
                maxLength={64}
                required={true}
                onChange={(_, value) => this._onChangeTextField('PrimerApellido', value)}
                errorMessage={this.state.errors[ 'PrimerApellido' ]}
                value={this.state.model.PrimerApellido}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder='Segundo apellido'
                label='Segundo apellido'
                maxLength={64}
                onChange={(_, value) => this._onChangeTextField('SegundoApellido', value)}
                errorMessage={this.state.errors[ 'SegundoApellido' ]}
                value={this.state.model.SegundoApellido}
              />
            </div>
          </div>
        </div>
      }

      {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaJuridica) &&
        <div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm12'>
              <TextField
                placeholder='Razon social'
                label='Razón social'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('Nombres', value)}
                errorMessage={this.state.errors[ 'Nombres' ]}
                value={this.state.model.Nombres}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder=''
                label='Nombre representante'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('NombreRepresentante', value)}
                errorMessage={this.state.errors[ 'NombreRepresentante' ]}
                value={this.state.model.NombreRepresentante}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder=''
                label='Correo electrónico representante'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('EmailRepresentante', value)}
                errorMessage={this.state.errors[ 'EmailRepresentante' ]}
                value={this.state.model.EmailRepresentante}
              />
            </div>
          </div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                placeholder=''
                label='Cargo'
                maxLength={128}
                required={true}
                onChange={(_, value) => this._onChangeTextField('CargoRepresentante', value)}
                errorMessage={this.state.errors[ 'CargoRepresentante' ]}
                value={this.state.model.CargoRepresentante}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <TextField
                label='Teléfono representante'
                maxLength={10}
                onChange={(_, value) => this._onChangeNumberTextFieldA('TelefonoRepresentante', value)}
                errorMessage={this.state.errors[ 'TelefonoRepresentante' ]}
                value={this.state.model.TelefonoRepresentante} />
            </div>
          </div>
        </div>
      }

      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm6'>
          <TextField
            placeholder={emailLabel}
            label={emailLabel}
            maxLength={128}
            required={true}
            onChange={(_, value) => this._onChangeTextField('Email', value)}
            errorMessage={this.state.errors[ 'Email' ]}
            value={this.state.model.Email}
          />
        </div>
        <div className='ms-Grid-col ms-u-sm6'>
          <TextField
            placeholder={confirmEmailLabel}
            label={confirmEmailLabel}
            maxLength={128}
            required={true}
            onChange={(_, value) => this._onChangeTextField('Email2', value)}
            errorMessage={this.state.errors[ 'Email2' ]}
            value={this.state.model.Email2}
          />
        </div>
      </div>

      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm6'>
          <ComboBox
            label='País de notificación'
            selectedKey={this.state.model.IdPais}
            onChange={(_, value) => this._onChangeComboBox('IdPais', value)}
            options={this.state.paisesCO}
            required={true}
            useComboBoxAsMenuWidth={true}
            errorMessage={this.state.errors[ 'IdPais' ]}
          />
        </div>
        <div className='ms-Grid-col ms-u-sm4'>
          <ComboBox
            label='Departamento de notificación'
            selectedKey={this.state.model.IdDepartamento}
            onChange={(_, value) => this._onChangeComboBox('IdDepartamento', value)}
            options={this.state.departamentosCO}
            useComboBoxAsMenuWidth={true}
            required={true}
            errorMessage={this.state.errors[ 'IdDepartamento' ]}
          />
        </div>
        <div className='ms-Grid-col ms-u-sm2'>
          <ComboBox
            label='Ciudad de notificación'
            selectedKey={this.state.model.IdCiudad}
            onChange={(_, value) => this._onChangeComboBox('IdCiudad', value)}
            options={this.state.ciudadesCO}
            useComboBoxAsMenuWidth={true}
            required={true}
            errorMessage={this.state.errors[ 'IdCiudad' ]}
          />
        </div>
      </div>

      {((this.state.model.IdTipoPersona) === TipoPersonaEnum.PersonaNatural) &&
        <div>
          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <DatePicker
                firstDayOfWeek={DayOfWeek.Sunday}
                strings={DatePickerStrings}
                label='Fecha de nacimiento'
                formatDate={onFormatDate}
                onSelectDate={this._OnChangeModelDate.bind(this, 'FechaNacimiento')}
                value={this.state.model.FechaNacimiento}
                allowTextInput={true}
              />
            </div>
            <div className='ms-Grid-col ms-u-sm6'>
              <ComboBox
                label='Género'
                selectedKey={this.state.model.IdGenero}
                onChange={(_, value) => this._onChangeComboBox('IdGenero', value)}
                options={this.state.generos}
                useComboBoxAsMenuWidth={true}
              />
            </div>
          </div>

          <div className='ms-Grid-row'>
            <div className='ms-Grid-col ms-u-sm6'>
              <ComboBox
                label='Nivel de escolaridad'
                selectedKey={this.state.model.IdNivelEducativo}
                onChange={(_, value) => this._onChangeComboBox('IdNivelEducativo', value)}
                options={this.state.nivelEducativo}
                useComboBoxAsMenuWidth={true}
              />
            </div>
            {this.state.mostrarProfesion &&
              <div className='ms-Grid-col ms-u-sm2'>
                <ComboBox
                  label='Profesión u oficio'
                  selectedKey={this.state.model.IdProfesion}
                  onChange={(_, value) => this._onChangeComboBox('IdProfesion', value)}
                  options={this.state.profesiones}
                  useComboBoxAsMenuWidth={true}
                />
              </div>
            }
          </div>
        </div>
      }

      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm6'>
          <TextField
            placeholder='Dirección física'
            label='Dirección física'
            maxLength={128}
            onChange={(_, value) => this._onChangeTextField('Direccion', value)}
            errorMessage={this.state.errors[ 'Direccion' ]}
            value={this.state.model.Direccion}
          />
        </div>
        <div className='ms-Grid-col ms-u-sm6'>
          <TextField
            placeholder='Barrio'
            label='Barrio'
            maxLength={100}
            onChange={(_, value) => this._onChangeTextField('Barrio', value)}
            errorMessage={this.state.errors[ 'Barrio' ]}
            value={this.state.model.Barrio}
          />
        </div>
      </div>

      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm6'>
          <TextField
            label='Celular'
            maxLength={10}
            onChange={(_, value) => this._onChangeNumberTextFieldA('Celular', value)}
            errorMessage={this.state.errors[ 'Celular' ]}
            value={this.state.model.Celular} />
        </div>
        <div className='ms-Grid-col ms-u-sm4'>
          <TextField
            label='Teléfono'
            maxLength={10}
            required={this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaJuridica}
            onChange={(_, value) => this._onChangeNumberTextFieldA('Telefono', value)}
            errorMessage={this.state.errors[ 'Telefono' ]}
            value={this.state.model.Telefono} />
        </div>
        <div className='ms-Grid-col ms-u-sm2'>
          <TextField
            label='Extensión'
            maxLength={8}
            onChange={(_, value) => this._onChangeNumberTextFieldA('Extension', value)}
            errorMessage={this.state.errors[ 'Extension' ]}
            value={this.state.model.Extension} />
        </div>
      </div>

      {this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && <>
        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.AutorizaNotificacionFisica === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionAutorizaNotificacionFisica.bind(this)}
              label={'¿Autoriza recibir notificación en la dirección registrada?'}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.AutorizaLlamadaCelular === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionAutorizaLlamadaCelular.bind(this)}
              label={'¿Autoriza notificación o recibir llamadas por Teléfono Celular?'}
            />
          </div>
        </div>

        <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm6'>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.AutorizaLlamadaFijo === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionAutorizaLlamadaFijo.bind(this)}
              label={'¿Autoriza recibir llamadas a su teléfono fijo?'}
            />
          </div>
          <div className='ms-Grid-col ms-u-sm6'>
            <ChoiceGroup
              defaultSelectedKey='0'
              selectedKey={this.state.model.AutorizaNotificacionEmail === true ? '1' : '0'}
              options={this.state.opcionesSeleccionGrupo}
              onChange={this._onChangeOpcionAutorizaNotificacionEmail.bind(this)}
              label={'¿Autoriza notificación por correo electrónico?'}
            />
          </div>
        </div>
      </>}



      <div className='ms-Grid-row'>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
          <ReCaptchaComponent
            onInitialize={component => {
              this._recaptcha = component;
              setTimeout(this._recaptcha.initialize, 2000);
            }}
          />
          <small style={{ color: 'red' }}> {this.state.errors[ 'recaptcha' ]}</small>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
          <PrimaryButton
            text='Actualizar'
            onClick={this._saveAsync.bind(this)}
          />
          <span>&nbsp;&nbsp;</span>
          <DefaultButton
            text='Volver a inicio'
            href='#/home'
          />
        </div>
      </div>
      <br />
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          Fecha última modificación {this.state.fechaModificacion}
        </div>
      </div>
    </div>
  }

  protected _onChangeModel(model: any): void { }

  protected _OnChangeModelDate(property: string, date: Date | null | undefined): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: date
      }
    });
    this._onChangeModel({
      ...(this.state.model as any),
      [ property ]: date
    });
  };

  private _checkEmail(): ValidationResult {
    const result: ValidationResult = new ValidationResult();
    if (this.state.model.Email.toLowerCase() != this.state.model.Email2.toLowerCase()) {
      result.hasError = true;
      result.errorMessage = 'Las direcciones de correo electrónico no coinciden';
    }
    return result;
  }

  private _onChangeTextField(property: string, value: string): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value
      }
    };
    this.setState(state);
  }

  private _onChangeNumberTextField(property: string, value: number): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value.toString()
      }
    };
    this.setState(state);
  }

  private _onChangeNumberTextFieldA(property: string, value: string): void {
    value = value.split('').filter(o => !isNaN(Number(o))).join('');
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value.toString()
      }
    };
    this.setState(state);
  }

  private async _onChangeComboBox(property: string, option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): Promise<void> {
    const state = {
      ...this.state,
      model: {
        ...this.state.model,
        [ property ]: Number(option.key)
      }
    };

    if (property === 'IdPais') {
      state.departamentosCO = state.departamentos.filter(o => o.countryId === Number(option.key)).map(o => ({ key: o.departmentId, text: o.name }));
      state.ciudadesCO = [];
      state.model.IdCiudad = 0;
    }

    if (property === 'IdDepartamento') {
      state.ciudadesCO = state.ciudades.filter(o => o.departmentId === Number(option.key)).map(o => ({ key: o.cityId, text: o.name }));
      state.model.IdCiudad = 0;
    }

    this.setState(state);

  }

  protected _changeModelCheckBox(property: string, ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean): void {
    this.setState({
      model: {
        ...(this.state.model as any),
        [ property ]: checked
      }
    });
  }

  private _updateErrors(errors: { [ key: string ]: string }): void {
    this.setState({ errors });
  }

  private _validationNatural: { [ key: string ]: any[] } = {
    PrimerNombre: [ validator.required(true), validator.maxLength(64), validator.onlyText() ],
    PrimerApellido: [ validator.required(true), validator.maxLength(64), validator.onlyText() ],
    SegundoNombre: [ validator.onlyText() ],
    SegundoApellido: [ validator.onlyText() ]
  };

  private _validationJuridica: { [ key: string ]: any[] } = {
    NombreRepresentante: [ validator.required(true), validator.maxLength(128) ],
    EmailRepresentante: [
      validator.required(true),
      validator.maxLength(128),
      validator.email() ],
    CargoRepresentante: [ validator.required(true), validator.maxLength(128) ],
    Telefono: [ validator.required(true), validator.maxLength(20) ],
    TelefonoRepresentante: [ validator.required(true), validator.maxLength(20) ],
  };

  private async _saveAsync(): Promise<void> {
    if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural) {
      this.state.model.Nombres = this.state.model.PrimerNombre + ' ' + this.state.model.SegundoNombre;
      this.state.model.Apellidos = this.state.model.PrimerApellido + ' ' + this.state.model.SegundoApellido;
    }
    else {
      this.state.model.Apellidos = this.state.model.NombreRepresentante;
    }

    let validations: { [ key: string ]: any[] };
    let _validationTipoEntidad: { [ key: string ]: any[] } = {};

    if (this.state.mostrarTipoSolicitante) {
      _validationTipoEntidad = {
        IdTipoEntidad: [ validator.invalid(0, 'Campo requerido') ]
      }
    }

    if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural) {
      let _validationAtencionPreferencial: { [ key: string ]: any[] } = {};
      let _validationIdentity: { [ key: string ]: any[] } = {};
      let _validationApoderado: { [ key: string ]: any[] } = {};
      let _validationNotificacionFisica: { [ key: string ]: any[] } = {};
      let _validationLlamadasFijo: { [ key: string ]: any[] } = {};
      let _validationLlamadasCelular: { [ key: string ]: any[] } = {};

      _validationAtencionPreferencial = {
        IdAntencionPreferencial: [ validator.invalid(0, 'Campo requerido') ]
      };

      if (this.state.model.IdTipoIdentificacion === TipoIdentificacionEnum.CedulaCiudadania) {
        _validationIdentity = {
          Identificacion: [ validator.required(true), validator.identity(), validator.maxLength(20) ]
        };
      }

      if (this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.Discapacidad) {
        _validationAtencionPreferencial = {
          IdDiscapacidad: [ validator.invalid(0, 'Campo requerido') ]
        };
      }
      else if (this.state.model.IdAntencionPreferencial === AtencionPreferencialEnum.GrupoEtnico) {
        _validationAtencionPreferencial = {
          IdGrupoEtnico: [ validator.invalid(0, 'Campo requerido') ]
        };
      }

      if (this.state.model.ActuaComoApoderado) {
        _validationApoderado = {
          IdentificacionApoderado: [ validator.required(true), validator.identity() ],
          IdTipoIdentificacionApoderado: [ validator.invalid(0, 'Campo requerido') ],
          NombresApoderado: [ validator.required(true) ],
          ApellidosApoderado: [ validator.required(true) ],
          EmailApoderado: [ validator.required(true) ]
        };
      }

      if (this.state.model.AutorizaLlamadaCelular) {
        _validationLlamadasCelular = {
          Celular: [ validator.invalid(0, 'Campo requerido') ]
        };
      }

      if (this.state.model.AutorizaLlamadaFijo) {
        _validationLlamadasFijo = {
          Telefono: [ validator.invalid(0, 'Campo requerido') ]
        };
      }

      if (this.state.model.AutorizaNotificacionFisica) {
        _validationNotificacionFisica = {
          Direccion: [ validator.required(true) ]
        };
      }

      validations = { ...this._validations, ...this._validationNatural, ..._validationAtencionPreferencial, ..._validationIdentity, ..._validationApoderado, ..._validationNotificacionFisica, ..._validationLlamadasCelular, ..._validationLlamadasFijo, ..._validationTipoEntidad }
    }
    else {
      validations = { ...this._validations, ...this._validationJuridica, ..._validationTipoEntidad }
    }

    if (validateObject(this.state.model, validations, this._updateErrors.bind(this))) {
      try {

        if (this.state.model.IdTipoPersona === TipoPersonaEnum.PersonaNatural && !$_.isNull(this.state.model.FechaNacimiento)) {
          const dtNow = DateTime.Now.TruncateDate();
          const dtValue = new DateTime(this.state.model.FechaNacimiento).TruncateDate();
          const dtOneMonthAgo = new Date(dtNow.getFullYear(), dtNow.getMonth() - 1, dtNow.getDate());

          // Comparar la fecha ingresada con la fecha un mes atrás
          if (dtValue > dtOneMonthAgo) {
            alert('Debe seleccionar una fecha válida de nacimiento');
            return;
          }
        }

        const resultCaptcha = this._recaptcha.isValid();
        if (resultCaptcha.isCaptchaValid === false) {
          alert('Debe completar la validación de seguridad.');
          return;
        }
        this.setState({ isSaving: true });
        await this._pqrWebService.updateContactAsync(this.state.model, resultCaptcha.recaptchaToken);
        this.setState({ isSaving: false });

        sessionStorage.setItem('ioip.pqr-web.session.idtipocontacto', this.state.model.IdTipoContacto.toString());
        sessionStorage.setItem('ioip.pqr-web.session.nombres', this.state.model.Nombres.toUpperCase());
        sessionStorage.setItem('ioip.pqr-web.session.apellidos', this.state.model.Apellidos.toUpperCase());
        sessionStorage.setItem('ioip.pqr-web.session.tipoid', this.state.model.IdTipoContacto.toString());
        sessionStorage.setItem('ioip.pqr-web.session.email', this.state.model.Email);
        sessionStorage.setItem('ioip.pqr-web.session.celular', this.state.model.Celular);
        sessionStorage.setItem('ioip.pqr-web.session.telefono', this.state.model.Telefono);
        sessionStorage.setItem('ioip.pqr-web.session.direccion', this.state.model.Direccion);
        sessionStorage.setItem('ioip.pqr-web.session.barrio', this.state.model.Barrio);
        sessionStorage.setItem('ioip.pqr-web.session.extension', this.state.model.Extension);
        sessionStorage.setItem('ioip.pqr-web.session.idpais', this.state.model.IdPais.toString());
        sessionStorage.setItem('ioip.pqr-web.session.iddepartamento', this.state.model.IdDepartamento.toString());
        sessionStorage.setItem('ioip.pqr-web.session.idciudad', this.state.model.IdCiudad.toString());
        sessionStorage.setItem('ioip.pqr-web.session.codigopostal', this.state.model.CodigoPostal);
        sessionStorage.setItem('ioip.pqr-web.session.idantencionpreferencial', this.state.model.IdAntencionPreferencial.toString());
        sessionStorage.setItem('ioip.pqr-web.session.iddiscapacidad', this.state.model.IdDiscapacidad.toString());
        sessionStorage.setItem('ioip.pqr-web.session.idgenero', this.state.model.IdGenero.toString());
        sessionStorage.setItem('ioip.pqr-web.session.idgrupoetnico', this.state.model.IdGrupoEtnico.toString());
        sessionStorage.setItem('ioip.pqr-web.session.nombrerepresentante', this.state.model.NombreRepresentante);
        sessionStorage.setItem('ioip.pqr-web.session.emailrepresentante', this.state.model.EmailRepresentante);
        sessionStorage.setItem('ioip.pqr-web.session.cargorepresentante', this.state.model.CargoRepresentante);
        sessionStorage.setItem('ioip.pqr-web.session.telefonorepresentante', this.state.model.TelefonoRepresentante);
        sessionStorage.setItem('ioip.pqr-web.session.idtipopersona', this.state.model.IdTipoPersona.toString());
        sessionStorage.setItem('ioip.pqr-web.session.primernombre', this.state.model.PrimerNombre);
        sessionStorage.setItem('ioip.pqr-web.session.segundonombre', this.state.model.SegundoNombre);
        sessionStorage.setItem('ioip.pqr-web.session.primerapellido', this.state.model.PrimerApellido);
        sessionStorage.setItem('ioip.pqr-web.session.segundoapellido', this.state.model.SegundoApellido);
        sessionStorage.setItem('ioip.pqr-web.session.idprofesion', this.state.model.IdProfesion.toString());
        sessionStorage.setItem('ioip.pqr-web.session.idnivelEducativo', this.state.model.IdNivelEducativo.toString());
        sessionStorage.setItem('ioip.pqr-web.session.fechaNacimiento', this.state.model.FechaNacimiento ? this.state.model.FechaNacimiento.toString() : '');
        sessionStorage.setItem('ioip.pqr-web.session.idtipoentidad', this.state.model.IdTipoEntidad.toString());

        sessionStorage.setItem('ioip.pqr-web.session.autorizatratamientodatos', this.state.model.AutorizaTratamientoDatos.toString());
        sessionStorage.setItem('ioip.pqr-web.session.autorizallamadacelular', this.state.model.AutorizaLlamadaCelular.toString());
        sessionStorage.setItem('ioip.pqr-web.session.autorizallamadafijo', this.state.model.AutorizaLlamadaFijo.toString());
        sessionStorage.setItem('ioip.pqr-web.session.autorizanotificacionemail', this.state.model.AutorizaNotificacionEmail.toString());
        sessionStorage.setItem('ioip.pqr-web.session.autorizanotificacionfisica', this.state.model.AutorizaNotificacionFisica.toString());
        sessionStorage.setItem('ioip.pqr-web.session.actuacomoapoderado', this.state.model.ActuaComoApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.idtipoidentificacionapoderado', this.state.model.IdTipoIdentificacionApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.identificacionapoderado', this.state.model.IdentificacionApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.nombresapoderado', this.state.model.NombresApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.apellidosapoderado', this.state.model.ApellidosApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.telefonoapoderado', this.state.model.TelefonoApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.direccionapoderado', this.state.model.DireccionApoderado.toString());
        sessionStorage.setItem('ioip.pqr-web.session.emailapoderado', this.state.model.EmailApoderado.toString());

        alert('Los datos fueron actualizados correctamente.');
        window.location.href = '#/home';

      } catch (ex) {
        alert((ex as any).exceptionMessage);
      }
    }
  }

  private get isAuthenticate(): boolean {
    const token = sessionStorage.getItem('ioip.pqr-web.session.token');
    if (token === null || token === undefined) {
      return false;
    }
    const date = sessionStorage.getItem('ioip.pqr-web.session.expiracion');
    return true;
  }


}